import { useMemo } from 'react';

import Button from '@polyai/ui/components/atoms/Button';
import { ExternalLinkIcon } from '@polyai/ui/components/atoms/Icons';

import {
  BROWSER_TARGET_LABEL,
  type BrowserTarget,
  buildBrowserHandoffUrl,
  detectInAppBrowser,
  type InAppBrowserPlatform,
  supportedBrowserTargets,
} from 'utils/inAppBrowser';

const handoff = (platform: InAppBrowserPlatform, target: BrowserTarget) => {
  const url = buildBrowserHandoffUrl(platform, target, window.location.href);
  if (url) {
    window.location.href = url;
  }
};

const InAppBrowserActions = () => {
  const info = useMemo(() => detectInAppBrowser(), []);
  const targets = info
    ? supportedBrowserTargets(info.platform)
    : ([] as BrowserTarget[]);

  if (!info || targets.length === 0) {
    return null;
  }

  return (
    <>
      {targets.map((target, i) => (
        <Button
          key={target}
          endAdornment={<ExternalLinkIcon />}
          label={BROWSER_TARGET_LABEL[target]}
          variant={i === 0 ? 'PRIMARY' : 'SECONDARY'}
          onClick={() => handoff(info.platform, target)}
        />
      ))}
    </>
  );
};

export default InAppBrowserActions;
